import { I18n } from '@calendly/i18n';
import { BodyText } from '@calendly/ui/components/typography';
import classNames from 'classnames';
import { forwardRef } from 'react';
import { ExternalEvent } from './external_event';
import { GroupEvent } from './group_event';
import { SoloEvent } from './solo_event';
import { WidgetContainer } from '../widget_container';
const headerContainerIsGroupCss = "hr3mqas";
const headerContainerCss = "hmvkg52";
const HeaderContainer = forwardRef((props, ref) => {
  const {
    isGroup,
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(headerContainerCss, {
    [headerContainerIsGroupCss]: isGroup
  }, props.className)} />;
});

/**
 * Pure presentational component for the invitees widget header.
 *
 * <table>
 *   <thead><tr><th>Prop</th><th>Type</th><th>Description</th></tr></thead>
 *   <tbody>
 *     <tr><td>isGroup</td><td>boolean</td><td>Whether this is a group event</td></tr>
 *     <tr><td>subtitle</td><td>string</td><td>Optional subtitle text (e.g., "3/10 spots filled")</td></tr>
 *     <tr><td>controls</td><td>React.ReactNode</td><td>Optional controls to render (export button, menu)</td></tr>
 *   </tbody>
 * </table>
 */
const HeaderView = ({
  isGroup,
  subtitle,
  controls
}) => <HeaderContainer isGroup={isGroup}>
    {subtitle && <BodyText color="muted" size="small">{subtitle}</BodyText>}
    {controls}
  </HeaderContainer>;

/**
 * Pure presentational component for the Invitees widget.
 * This component accepts pre-computed state as props, making it easy to test
 * in isolation and use in Storybook.
 *
 * @param {Object} props
 * @param {Object} props.event - The meeting event object
 * @param {boolean} props.readonly - Whether the widget is in readonly mode
 * @param {boolean} props.isGroup - Whether this is a group event (pre-computed)
 * @param {boolean} props.isPast - Whether the event is in the past (pre-computed)
 * @param {boolean} props.isCalendlyEvent - Whether this is a Calendly event (pre-computed)
 * @param {string} props.subtitle - Optional subtitle text for the header
 * @param {React.ReactNode} props.headerControls - Optional controls for the header
 * @param {boolean} props.shouldHide - Whether to hide the widget (pre-computed)
 */
export const InviteesWidgetView = ({
  event,
  readonly,
  isGroup,
  isPast,
  isCalendlyEvent,
  subtitle,
  headerControls,
  shouldHide
}) => {
  if (shouldHide) {
    return null;
  }
  const title = isPast ? I18n.t('publisher.meetings.invitees.attendees') : I18n.t('publisher.meetings.invitees.invitees');
  return <WidgetContainer title={title} header={<HeaderView isGroup={isGroup} subtitle={subtitle} controls={headerControls} />} noPadding>
      {isCalendlyEvent && isGroup && <GroupEvent key={event.id} event={event} readonly={readonly} />}
      {isCalendlyEvent && !isGroup && <SoloEvent key={event.id} event={event} readonly={readonly} />}
      {!isCalendlyEvent && <ExternalEvent event={event} readonly={readonly} />}
    </WidgetContainer>;
};

require("./invitees_widget_view.wyw-in-js.css!=!../../../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./invitees_widget_view.js");